import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components";
import { Link, navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image";
import { DropArrowIcon, CloseIcon, SearchIcon, SearchCloseIcon } from "../Icons";
import BreakpointDown from "../Media/BreakpointDown";
import BreakpointUp from "../Media/BreakpointUp";
import FinancingDropdown from "./DropDown/financing-dropdown";
import ResourcesDropdown from "./DropDown/resources-dropdown";
import { Container, DropSearch, DropSearchBody, DropSearchItem } from "../Section";
import WhiteButton from "../Button/WhiteButton";
import MetalBuildingsDropdown from "./DropDown/metal-buildings-dropdown";
import { useSearch } from "../../useSearch";
import CartButton from "./CartButton"
import TruckGif from "../../images/truck.gif";
import CallGif from "../../images/calll.gif";
import EstimatorGif from "../../images/estimator.gif";
import Markquee from "../Marquee"

const HeaderWrapper = styled.header`
  position: fixed;
  z-index: 11;
  left: 0;
  right: 0;
  top: 0;
  height: 64px;
  background-color: #fff;
  z-index: 999;
  /* box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1); */
  ${BreakpointUp.xl`
    height:100px;
  `}

  &:after{
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    bottom: 0px;
    background: #E9242A;
    right: 0;

    left: calc(100% - 20px);
    @media (min-width: 992px) {
      left: calc(100% - 40px);
    }
    @media (min-width: 1400px) {
      left: 75%;
    }
    @media (min-width: 1600px) {
      left: 65%;
    }
  }

`;
const HeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavBrand = styled(Link)`
  width: 100%;
  max-width: 86px;
  @media (min-width: 1200px) {
    max-width: 90px;
  }
  @media (min-width: 1400px) {
    max-width: 120px;
  }
`;

const NavbarNav = styled.ul`

  display: flex;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  margin: 0;

  ${BreakpointDown.xl`
    flex-direction:column;
    width:100%;
    flex: auto;
    justify-content: inherit;
  `}
`;
const NavItem = styled.li`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  ${BreakpointUp.xl`
    width:auto;
  `}
  + li {
    border-bottom: 1px solid #c6c6c6;
    ${BreakpointUp.xl`
      border-bottom:none;
    `}
  }
  .dropdown-menu {
    ${BreakpointUp.xl`
      display: block;
      visibility: hidden;
      opacity: 0;
      transition: all 0.4s cubic-bezier(0.3, 0, 0, 1.3) 0s;
    `}
  }

  &.nav-shop {
    display: none;
    @media (min-width: 1366px) {
      display: flex;
    }
  }

  .nav-link {
    color: #161420;
    > a {
      color: #161420;
      @media (min-width: 1200px) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        &:before,
        &:after {
          content: "";
          transition: 0.5s all ease;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          position: absolute;
          width: 0;
          height: 1px;
          background: rgba(255, 255, 255, 0.5);
        }
        &:before {
          right: 0;
          top: 0;
        }
        &:after {
          left: 0;
          bottom: 0;
        }
      }
    }
    .text {
      display: inline-flex;
      + .icon {
        margin-left: 5px;
      }
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        margin-bottom: 0;
      }
    }
    .caret {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease 0s;
      padding: 0;
      transform: rotate(0deg);
      width: 30px;
      height: 30px;
      @media (min-width: 1200px) {
        width: 10px;
        height: 10px;
      }
      > svg {
        fill: #161420;
        width: 15px;
        height: 15px;
        @media (min-width: 1200px) {
          width: 8px;
          height: 8px;
        }
      }
    }
  }

  &:hover,
  &.active {
    .nav-link {
      /* color:#e9242a; */
      font-weight: 600;
      > a {
        /* color:#e9242a; */
        @media (min-width: 1200px) {
          &:before,
          &:after {
            width: 100%;
            background: #E9242A;
          }
        }
        .shop {
          color: #000;
        }
      }
      @media (min-width: 1200px) {
        .caret {
          transform: rotate(180deg);
          > svg {
            fill: #161420;
          }
        }
      }
    }
    .dropdown-menu {
      ${BreakpointUp.xl`
        display: block;
        visibility: visible;
        opacity: 1;
        pointer-events: auto;
        transform: none;
      `}
    }
  }

  &:last-child {
    .dropdown-menu {
      ${BreakpointUp.xl`
        right:0;
        left:auto;
      `}
    }
  }
`;

const NavLink = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.5px;
  padding: 10px 0;

  font-size: 16px;
  line-height: 30px;
  @media (min-width: 1200px) {
    font-size: 14px;
    padding: 30px 10px;
    line-height: 40px;
  }
  @media (min-width: 1280px) {
    line-height: 40px;
    font-size: 16px;
  }
  .text {
    + .caret {
      margin-left: auto;
      @media (min-width: 1200px) {
        margin-left: 5px;
      }
    }
    &.shop {
      /* text-transform: uppercase; */
      color:#E9242A;
    }
  }
  .caret {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease 0s;
    width: 10px;
    height: 10px;
    padding: 0;
    transform: rotate(0deg);
  }
  .icon {
    align-items: center;
    justify-content: center;
    /* width: 20px;
    height: 20px; */
    display: none !important;
    @media (min-width: 1200px) {
      display: flex !important;
    }
  }
`;
const Navbar = styled.div`
  /* position:relative; */
  width: 100%;
  padding: 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;

  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  width: 100%;

  /* &:after {
    content: "";
    display: block;
    position: absolute;
    left: calc(100% - 31px);
    height: 100%;
    bottom: 0px;
    width: 100%;
    background: #E9242A;
  } */
`;
const MainNavBar = styled.div`
  flex: 1;
  justify-content: flex-end;
  position:relative;
  display: flex;
`;
const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position:relative;
  .close-menu {
    position: fixed;
    top: 15px;
    right: 15px;
    z-index: 99;
    display: block;
    svg {
      fill: #161420;
      width: 20px;
      height: 15px;
    }
    ${BreakpointUp.xl` 
      display: none;
    `}
    &:hover {
      svg {
        fill: #e08932;
      }
    }
  }

  ${BreakpointDown.xl`
    padding:30px 20px;
    flex-direction: column-reverse;
    width: 0;
    position: fixed;
    top: 64px;
    right: 0;
    height: calc(100vh - 64px);
    z-index: 99;
    transition: all 0.4s cubic-bezier(0.4,0,0.2,1) 0s;
    transform: translate3d(100%,0,0);
    overflow-y: auto;
    display: block;
    background: #fff;
    z-index: -1;
  `}
`;
const TopNav = styled.div`
  position: relative;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  height: 64px;
  padding: 0 0 0 20px;
  /* margin: 0 -5px; */
  @media (min-width: 576px) {
    padding: 0 0 0 30px;
  }
  @media (min-width: 1200px) {
    height: auto;
  }
  @media (min-width: 1366px) {
    padding: 0 15px 0 40px;
  }

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: #E9242A;
    clip-path: polygon(10% 0, 100% 0%, 100% 100%, 0% 100%);
  }
  /* &:after {
    content: "";
    display: block;
    position: absolute;
    left: calc(100% - 31px);
    height: 100%;
    bottom: 0px;
    width: 100%;
    background: #E9242A;
  } */
`;
const TopNavItem = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  .btn,
  .btn-custom,
  .btn-cta,
  .btn-3d,
  .btn-search,
  .btn-cart {    
    .icon {
      width: 30px;
      height: 30px;
      @media (min-width: 768px) {
        width:36px;
        height:36px;
      }
      @media (min-width: 1600px) {
        width:38px;
        height:38px;
      }
      @media (max-width: 575.98px) {
        padding:6px !important;
      }
    }
    .text {
      display: none;
      @media (min-width: 1200px) {
        display: inline-flex;
      }
    }
    .btn{
      background-color:#F9D2D2;
      &:hover{
        color:#000;
        .icon{
          svg{
            fill:#000;
          }
        }
      }

    }
  }

  .btn-cta,
  .btn-3d,
  .btn-search,
  .btn-cart {
    display:flex;
  }

  &.hamburger-menu {
    display: flex;
    @media (min-width: 1200px) {
      display: none;
    }
  }
  .hamburger {
    vertical-align: middle;
    display: inline-block;
  }

  &.search, &.phone{
    @media (max-width: 767.98px) {
      display: none;
    }
  }
`;
const ShopNav = styled.div`
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 15px;
  font-size: 14px;
  line-height: 20px;
  @media (min-width: 1366px) {
    display: none;
  }
  > a {
    color: #e9242a;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
  }
  .icon {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 30px;
    margin-bottom: 2px;
    img {
      margin-bottom: 0;
    }
  }
`;

const SearchForm = styled.div`
  background-color: rgba(255,255,255,0.8);
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  backdrop-filter: blur(8px);
  width: 100%;
  margin: 0 auto;
  transition: all 0.5s;
  @media (min-width: 768px) {
    transform: translateY(-100%);
    position: absolute;
    z-index: 1000;
    left: 0;
    top: 0;
    &.show {
      transform: translateY(0);
    }
  }
  &.top-search{
    @media (max-width: 767.98px) {
      display:none;
    }
  }
  &.nav-search{
    .input-icon.right > .form-control{
      padding-left:0;
    }
    @media (min-width: 768px) {
      display:none;
    }
  }
`;

const SearchContainer = styled.div`
  position: relative;
  max-width: 1410px;
  width: 100%;
  margin: 0px auto;
  @media (min-width: 1200px) {
    padding: 0px 30px;
  }
  .input-icon {
    > .form-control {
      padding: 5px 15px;
      @media (min-width: 768px) {
        padding: 17px 15px;
      }
      @media (min-width: 1200px) {
        padding: 35px 15px;
      }
      @media (min-width: 1600px) {
        padding: 35px 15px;
      }

      &::placeholder {
        color: #373636;
      }
      &:focus,
      &:active {
        &::placeholder {
          color: #373636;
        }
      }
    }
    .icon {
      cursor: pointer;
      width: 45px;
      > svg {
        fill: #373636;
        width: 15px;
        height: 15px;
      }
      &:hover {
        > svg {
          fill: #e9242a;
        }
      }
    }
    &.right {
      > .form-control {
        padding-right: 45px;
        padding-left: 15px;
      }
    }
  }
`;
const Header = ({ location }) => {
  const [isMenu, setisMenu] = useState(false);
  const [isDropDown, setDropDown] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [showSearch, setShowSearch] = useState(true);
  const [showSearchDropDown, setShowSearchDropDown] = useState(false);
  const searchInputRef = useRef();
  const targetRef = useRef(null);

  const handleClickOutside = (event) => {
    if (targetRef.current && !targetRef.current.contains(event.target)) {
      if (event.target.id !== searchInputRef.current.id) {
        setShowSearchDropDown(false);
      }
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [])

  let hideSearch = false;
  if (location.pathname.startsWith("/search-result/")) {
    hideSearch = true;
  }

  const handleChange = (e) => {
    setSearchKey(e.target.value);
  };

  const handleSubmit = (e) => {
    if (!searchKey) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    navigate("/search-result", { state: { searchKey: searchKey } });
  };

  const toggleSearch = () => {
    if (showSearch) {
      setTimeout(() => searchInputRef.current.focus(), 500)
    } else {
      setSearchKey("");
    }
    setShowSearch(!showSearch);
  };

  function hangleDropDown(index) {
    if (isDropDown === index) {
      return setDropDown(null);
    }
    setDropDown(index);
  }

  useEffect(() => {
    document.body.classList.toggle("menu-open", isMenu);
  }, [isMenu, setisMenu]);

  const { results } = useSearch(searchKey, "", true);

  return (
    <>
    <HeaderWrapper id="myHeader">
      <Container>
        <HeaderInner>
          <NavBrand to="/">
            <StaticImage
              src="../../images/logo.svg"
              placeholder="blurred"
              alt="EMB Metal Buildings"
            />
          </NavBrand>
          <Navbar>
            <MainNavBar>
              <SearchForm className={showSearch ? "search-form top-search" : "search-form top-search show"}>
                <SearchContainer className="search-container">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="input-icon right">
                      <input
                        ref={searchInputRef}
                        className="form-control"
                        type="text"
                        placeholder="Search By Product..."
                        id="search"
                        name="search"
                        onFocus={() => setShowSearchDropDown(true)}
                        autoComplete="off"
                        value={searchKey}
                        onChange={(e) => handleChange(e)}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            setShowSearchDropDown(false);
                          }
                        }}
                      />
                      <button
                        type="button"
                        aria-label="Close Search"
                        className="icon"
                        onClick={toggleSearch}
                      >
                        <SearchCloseIcon />
                      </button>
                    </div>
                  </form>
                  {showSearchDropDown && (
                    <DropSearch className='drop-search' ref={targetRef}>
                      <DropSearchBody>
                        {!!results && results.map((item, i) => (
                          <DropSearchItem
                            key={i}
                            onClick={() => {
                              if (item.type === "tag") {
                                navigate("/shop", {
                                  state: { tag: item.title },
                                })
                              } else {
                                navigate(item.url);
                              }
                            }}
                          >
                            {item.title}
                          </DropSearchItem>
                        ))}
                      </DropSearchBody>
                    </DropSearch>
                  )}
                </SearchContainer>
              </SearchForm>
              <ShopNav>
                <Link to="/shop/">
                  <span className="icon">
                    <img src={TruckGif} alt="EMB Metal Buildings" />                    
                  </span>
                  <span className="text">Shop</span>
                </Link>
              </ShopNav>
              <Nav className="nav">
                {!hideSearch && (
                  <SearchForm
                    className={showSearch ? "search-form nav-search show" : "search-form nav-search show"}
                  >
                    <SearchContainer className="search-container">
                      <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="input-icon right">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search By Product..."
                            id="search"
                            name="search"
                            onChange={(e) => handleChange(e)}
                          />
                          <button
                            type="button"
                            aria-label="Close Search"
                            className="icon"
                            onClick={handleSubmit}
                          >
                            <SearchIcon />
                          </button>
                        </div>
                      </form>
                    </SearchContainer>
                  </SearchForm>
                )}
                <NavbarNav>
                  <NavItem
                    className={
                      location?.pathname &&
                        location.pathname === "/shop/"
                        ? "active nav-shop"
                        : "nav-shop"
                    }
                  >
                    <NavLink className="nav-link">
                      <Link to="/shop/">
                        <span className="text shop">Shop Now</span>{" "}
                        <span className="icon">
                          <img src={TruckGif} alt="EMB Metal Buildings" />
                        </span>
                      </Link>
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink className="nav-link">
                      <span role="button" tabIndex="0" className="text">
                        Building Styles
                      </span>
                      <button
                        aria-label="span"
                        className="caret"
                        onClick={() => hangleDropDown(1)}
                      >
                        {isDropDown === 1 ? <CloseIcon /> : <DropArrowIcon />}
                      </button>                      
                    </NavLink>
                    <MetalBuildingsDropdown
                      isActive={isDropDown === 1 ? true : false}
                    />
                  </NavItem>

                  <NavItem>
                    <NavLink className="nav-link">
                      <Link to="/service-area/" role="button" tabIndex="0" className="text">
                      Service Area
                      </Link>
                      <button
                        aria-label="span"
                        className="caret"
                        onClick={() => hangleDropDown(2)}
                      >
                        {isDropDown === 2 ? <CloseIcon /> : <DropArrowIcon />}
                      </button>
                    </NavLink>
                    <FinancingDropdown
                      isActive={isDropDown === 2 ? true : false}
                    />
                  </NavItem>

                  <NavItem>
                    <NavLink className="nav-link">
                      <span role="button" tabIndex="0" className="text">
                        Resources
                      </span>
                      <button
                        aria-label="span"
                        className="caret"
                        onClick={() => hangleDropDown(3)}
                      >
                        {isDropDown === 3 ? <CloseIcon /> : <DropArrowIcon />}
                      </button>
                    </NavLink>
                    <ResourcesDropdown
                      isActive={isDropDown === 3 ? true : false}
                    />
                  </NavItem>

                  <NavItem
                    className={
                      location?.pathname && location.pathname === "/contact-us/"
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink className="nav-link">
                      <Link to="/contact-us/">Contact Us</Link>
                    </NavLink>
                  </NavItem>
                </NavbarNav>
              </Nav>
            </MainNavBar>
            <TopNav className="topnav">
              {!hideSearch && <TopNavItem className="topnav-item search">
                <button type="button" aria-label="Search" className="btn-search" onClick={toggleSearch}>
                  <WhiteButton icon={<SearchIcon />} size="sm" />
                </button>
              </TopNavItem>}
              <TopNavItem className="topnav-item phone">
                <a
                  href="tel:2085721441"
                  aria-label="phone number"
                  className="btn-cta"
                >
                  <span className="btn btn-white btn-sm">
                    <span className="icon"><img src={CallGif} alt="EMB Metal Buildings" /></span>
                    <span className="text">(208) 572-1441</span>
                  </span>
                </a>
              </TopNavItem>
              <TopNavItem className="topnav-item 3d">
                <a
                  href="https://engineeredmetalbuildings.sensei3d.com/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Start Building"
                  className="btn-3d"
                >
                  <span className="btn btn-white btn-sm">
                    <span className="icon"><img src={EstimatorGif} alt="EMB Metal Buildings" /></span>
                    <span className="text">Start Building</span>
                  </span>
                </a>
              </TopNavItem>
              <TopNavItem className="topnav-item cart">
                <Link className="btn-cart" to="/cart"><CartButton /></Link>
              </TopNavItem>
              <TopNavItem className="topnav-item hamburger-menu">
                <button
                  type="button"
                  aria-label="Hamburger Menu"
                  onClick={() => setisMenu(!isMenu)}
                  className="hamburger icon"
                >
                  <i className="line icn"></i>
                </button>
              </TopNavItem>
            </TopNav>
          </Navbar>
        </HeaderInner>
      </Container>
    </HeaderWrapper>
    <Markquee />
    </>
  );
};

export default Header;